module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-25.caa0753.woff2";